/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsPreview,
    MelcoModelsPreviewFromJSON,
    MelcoModelsPreviewFromJSONTyped,
    MelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsAlphabetListItem
 */
export interface MelcoModelsAlphabetListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsAlphabetListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsAlphabetListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsAlphabetListItem
     */
    type?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsPreview>}
     * @memberof MelcoModelsAlphabetListItem
     */
    previews?: Array<MelcoModelsPreview> | null;
}

export function MelcoModelsAlphabetListItemFromJSON(json: any): MelcoModelsAlphabetListItem {
    return MelcoModelsAlphabetListItemFromJSONTyped(json, false);
}

export function MelcoModelsAlphabetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsAlphabetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(MelcoModelsPreviewFromJSON)),
    };
}

export function MelcoModelsAlphabetListItemToJSON(value?: MelcoModelsAlphabetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(MelcoModelsPreviewToJSON)),
    };
}


